import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRegister } from "./RegisterContext";
import ButtonPrimary from "./components/ButtonPrimary";
import logo from "./resources/cadmus_dark.svg";
import apiClient from "./utils/apiClient";

// Full world country list with culture_info + flag emoji
const COUNTRIES = [
  { label: "Afghanistan", value: "af-AF", flag: "🇦🇫" },
  { label: "Albania", value: "sq-AL", flag: "🇦🇱" },
  { label: "Algeria", value: "ar-DZ", flag: "🇩🇿" },
  { label: "Andorra", value: "ca-AD", flag: "🇦🇩" },
  { label: "Angola", value: "pt-AO", flag: "🇦🇴" },
  { label: "Argentina", value: "es-AR", flag: "🇦🇷" },
  { label: "Armenia", value: "hy-AM", flag: "🇦🇲" },
  { label: "Australia", value: "en-AU", flag: "🇦🇺" },
  { label: "Austria", value: "de-AT", flag: "🇦🇹" },
  { label: "Azerbaijan", value: "az-AZ", flag: "🇦🇿" },
  { label: "Bahrain", value: "ar-BH", flag: "🇧🇭" },
  { label: "Bangladesh", value: "bn-BD", flag: "🇧🇩" },
  { label: "Belarus", value: "be-BY", flag: "🇧🇾" },
  { label: "Belgium", value: "nl-BE", flag: "🇧🇪" },
  { label: "Bolivia", value: "es-BO", flag: "🇧🇴" },
  { label: "Bosnia and Herzegovina", value: "bs-BA", flag: "🇧🇦" },
  { label: "Brazil", value: "pt-BR", flag: "🇧🇷" },
  { label: "Bulgaria", value: "bg-BG", flag: "🇧🇬" },
  { label: "Cambodia", value: "km-KH", flag: "🇰🇭" },
  { label: "Cameroon", value: "fr-CM", flag: "🇨🇲" },
  { label: "Canada", value: "en-CA", flag: "🇨🇦" },
  { label: "Chile", value: "es-CL", flag: "🇨🇱" },
  { label: "China", value: "zh-CN", flag: "🇨🇳" },
  { label: "Colombia", value: "es-CO", flag: "🇨🇴" },
  { label: "Costa Rica", value: "es-CR", flag: "🇨🇷" },
  { label: "Croatia", value: "hr-HR", flag: "🇭🇷" },
  { label: "Cuba", value: "es-CU", flag: "🇨🇺" },
  { label: "Cyprus", value: "el-CY", flag: "🇨🇾" },
  { label: "Czech Republic", value: "cs-CZ", flag: "🇨🇿" },
  { label: "Denmark", value: "da-DK", flag: "🇩🇰" },
  { label: "Dominican Republic", value: "es-DO", flag: "🇩🇴" },
  { label: "Ecuador", value: "es-EC", flag: "🇪🇨" },
  { label: "Egypt", value: "ar-EG", flag: "🇪🇬" },
  { label: "El Salvador", value: "es-SV", flag: "🇸🇻" },
  { label: "Estonia", value: "et-EE", flag: "🇪🇪" },
  { label: "Ethiopia", value: "am-ET", flag: "🇪🇹" },
  { label: "Finland", value: "fi-FI", flag: "🇫🇮" },
  { label: "France", value: "fr-FR", flag: "🇫🇷" },
  { label: "Georgia", value: "ka-GE", flag: "🇬🇪" },
  { label: "Germany", value: "de-DE", flag: "🇩🇪" },
  { label: "Ghana", value: "en-GH", flag: "🇬🇭" },
  { label: "Greece", value: "el-GR", flag: "🇬🇷" },
  { label: "Guatemala", value: "es-GT", flag: "🇬🇹" },
  { label: "Honduras", value: "es-HN", flag: "🇭🇳" },
  { label: "Hong Kong", value: "zh-HK", flag: "🇭🇰" },
  { label: "Hungary", value: "hu-HU", flag: "🇭🇺" },
  { label: "Iceland", value: "is-IS", flag: "🇮🇸" },
  { label: "India", value: "hi-IN", flag: "🇮🇳" },
  { label: "Indonesia", value: "id-ID", flag: "🇮🇩" },
  { label: "Iran", value: "fa-IR", flag: "🇮🇷" },
  { label: "Iraq", value: "ar-IQ", flag: "🇮🇶" },
  { label: "Ireland", value: "en-IE", flag: "🇮🇪" },
  { label: "Israel", value: "he-IL", flag: "🇮🇱" },
  { label: "Italy", value: "it-IT", flag: "🇮🇹" },
  { label: "Jamaica", value: "en-JM", flag: "🇯🇲" },
  { label: "Japan", value: "ja-JP", flag: "🇯🇵" },
  { label: "Jordan", value: "ar-JO", flag: "🇯🇴" },
  { label: "Kazakhstan", value: "kk-KZ", flag: "🇰🇿" },
  { label: "Kenya", value: "sw-KE", flag: "🇰🇪" },
  { label: "Kuwait", value: "ar-KW", flag: "🇰🇼" },
  { label: "Latvia", value: "lv-LV", flag: "🇱🇻" },
  { label: "Lebanon", value: "ar-LB", flag: "🇱🇧" },
  { label: "Libya", value: "ar-LY", flag: "🇱🇾" },
  { label: "Liechtenstein", value: "de-LI", flag: "🇱🇮" },
  { label: "Lithuania", value: "lt-LT", flag: "🇱🇹" },
  { label: "Luxembourg", value: "fr-LU", flag: "🇱🇺" },
  { label: "Malaysia", value: "ms-MY", flag: "🇲🇾" },
  { label: "Malta", value: "mt-MT", flag: "🇲🇹" },
  { label: "Mexico", value: "es-MX", flag: "🇲🇽" },
  { label: "Moldova", value: "ro-MD", flag: "🇲🇩" },
  { label: "Monaco", value: "fr-MC", flag: "🇲🇨" },
  { label: "Montenegro", value: "sr-ME", flag: "🇲🇪" },
  { label: "Morocco", value: "ar-MA", flag: "🇲🇦" },
  { label: "Myanmar", value: "my-MM", flag: "🇲🇲" },
  { label: "Nepal", value: "ne-NP", flag: "🇳🇵" },
  { label: "Netherlands", value: "nl-NL", flag: "🇳🇱" },
  { label: "New Zealand", value: "en-NZ", flag: "🇳🇿" },
  { label: "Nicaragua", value: "es-NI", flag: "🇳🇮" },
  { label: "Nigeria", value: "en-NG", flag: "🇳🇬" },
  { label: "North Korea", value: "ko-KP", flag: "🇰🇵" },
  { label: "North Macedonia", value: "mk-MK", flag: "🇲🇰" },
  { label: "Norway", value: "nb-NO", flag: "🇳🇴" },
  { label: "Oman", value: "ar-OM", flag: "🇴🇲" },
  { label: "Pakistan", value: "ur-PK", flag: "🇵🇰" },
  { label: "Panama", value: "es-PA", flag: "🇵🇦" },
  { label: "Paraguay", value: "es-PY", flag: "🇵🇾" },
  { label: "Peru", value: "es-PE", flag: "🇵🇪" },
  { label: "Philippines", value: "fil-PH", flag: "🇵🇭" },
  { label: "Poland", value: "pl-PL", flag: "🇵🇱" },
  { label: "Portugal", value: "pt-PT", flag: "🇵🇹" },
  { label: "Qatar", value: "ar-QA", flag: "🇶🇦" },
  { label: "Romania", value: "ro-RO", flag: "🇷🇴" },
  { label: "Russia", value: "ru-RU", flag: "🇷🇺" },
  { label: "Saudi Arabia", value: "ar-SA", flag: "🇸🇦" },
  { label: "Senegal", value: "fr-SN", flag: "🇸🇳" },
  { label: "Serbia", value: "sr-RS", flag: "🇷🇸" },
  { label: "Singapore", value: "en-SG", flag: "🇸🇬" },
  { label: "Slovakia", value: "sk-SK", flag: "🇸🇰" },
  { label: "Slovenia", value: "sl-SI", flag: "🇸🇮" },
  { label: "South Africa", value: "en-ZA", flag: "🇿🇦" },
  { label: "South Korea", value: "ko-KR", flag: "🇰🇷" },
  { label: "Spain", value: "es-ES", flag: "🇪🇸" },
  { label: "Sri Lanka", value: "si-LK", flag: "🇱🇰" },
  { label: "Sweden", value: "sv-SE", flag: "🇸🇪" },
  { label: "Switzerland", value: "de-CH", flag: "🇨🇭" },
  { label: "Syria", value: "ar-SY", flag: "🇸🇾" },
  { label: "Taiwan", value: "zh-TW", flag: "🇹🇼" },
  { label: "Tanzania", value: "sw-TZ", flag: "🇹🇿" },
  { label: "Thailand", value: "th-TH", flag: "🇹🇭" },
  { label: "Tunisia", value: "ar-TN", flag: "🇹🇳" },
  { label: "Turkey", value: "tr-TR", flag: "🇹🇷" },
  { label: "Uganda", value: "en-UG", flag: "🇺🇬" },
  { label: "Ukraine", value: "uk-UA", flag: "🇺🇦" },
  { label: "United Arab Emirates", value: "ar-AE", flag: "🇦🇪" },
  { label: "United Kingdom", value: "en-GB", flag: "🇬🇧" },
  { label: "United States", value: "en-US", flag: "🇺🇸" },
  { label: "Uruguay", value: "es-UY", flag: "🇺🇾" },
  { label: "Uzbekistan", value: "uz-UZ", flag: "🇺🇿" },
  { label: "Venezuela", value: "es-VE", flag: "🇻🇪" },
  { label: "Vietnam", value: "vi-VN", flag: "🇻🇳" },
  { label: "Yemen", value: "ar-YE", flag: "🇾🇪" },
  { label: "Zimbabwe", value: "en-ZW", flag: "🇿🇼" },
];

const labelStyle = {
  fontSize: "13px",
  fontFamily: "DM Sans",
  fontWeight: "600",
  color: "#111",
  marginBottom: "6px",
  marginTop: "12px",
  display: "block",
  textAlign: "left",
};

const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  border: "1px solid #E0E0E0",
  borderRadius: "8px",
  fontFamily: "DM Sans",
  fontSize: "14px",
  fontWeight: "400",
  color: "#111",
  boxSizing: "border-box",
  outline: "none",
  background: "white",
};

// Custom country dropdown with flags and search
function CountryDropdown({ value, onChange, hasError }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);
  const searchRef = useRef(null);

  const selected = COUNTRIES.find((c) => c.value === value);
  const filtered = COUNTRIES.filter((c) =>
    c.label.toLowerCase().includes(search.toLowerCase())
  );

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Focus search when opened
  useEffect(() => {
    if (open && searchRef.current) {
      setTimeout(() => searchRef.current?.focus(), 50);
    }
  }, [open]);

  return (
    <div ref={ref} style={{ position: "relative", width: "100%" }}>
      {/* Trigger */}
      <div
        onClick={() => setOpen((p) => !p)}
        style={{
          ...inputStyle,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          color: selected ? "#111" : "rgba(17,17,17,0.4)",
          userSelect: "none",
          borderColor: hasError ? "#E91D51" : "#E0E0E0",
        }}
      >
        <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {selected ? (
            <>
              <span style={{ fontSize: "20px", lineHeight: 1 }}>{selected.flag}</span>
              <span>{selected.label}</span>
            </>
          ) : (
            <span>Select country you are based in</span>
          )}
        </span>
        <svg
          width="12" height="12" viewBox="0 0 24 24" fill="none"
          stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s", flexShrink: 0 }}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </div>

      {/* Dropdown panel */}
      {open && (
        <div style={{
          position: "absolute",
          top: "calc(100% + 6px)",
          left: 0,
          right: 0,
          background: "white",
          border: "1px solid #E0E0E0",
          borderRadius: "10px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          zIndex: 999,
          overflow: "hidden",
        }}>
          {/* Search box */}
          <div style={{ padding: "10px 10px 6px 10px", borderBottom: "1px solid #F0F0F0" }}>
            <div style={{ position: "relative" }}>
              <svg
                style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}
                width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="#aaa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input
                ref={searchRef}
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search country..."
                style={{
                  width: "100%",
                  padding: "8px 10px 8px 32px",
                  border: "1px solid #E8E8E8",
                  borderRadius: "6px",
                  fontFamily: "DM Sans",
                  fontSize: "13px",
                  color: "#111",
                  outline: "none",
                  boxSizing: "border-box",
                  background: "#FAFAFA",
                }}
              />
            </div>
          </div>

          {/* Country list */}
          <div style={{ maxHeight: "220px", overflowY: "auto" }}>
            {filtered.length === 0 ? (
              <div style={{ padding: "16px", textAlign: "center", color: "#aaa", fontFamily: "DM Sans", fontSize: "13px" }}>
                No countries found
              </div>
            ) : (
              filtered.map((c) => (
                <div
                  key={c.value}
                  onClick={() => {
                    onChange(c.value);
                    setOpen(false);
                    setSearch("");
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "10px 14px",
                    cursor: "pointer",
                    background: c.value === value ? "#F5F2FF" : "white",
                    borderLeft: c.value === value ? "3px solid #6C44D4" : "3px solid transparent",
                    transition: "background 0.1s",
                    fontFamily: "DM Sans",
                    fontSize: "14px",
                    color: "#111",
                  }}
                  onMouseEnter={(e) => {
                    if (c.value !== value) e.currentTarget.style.background = "#F9F9F9";
                  }}
                  onMouseLeave={(e) => {
                    if (c.value !== value) e.currentTarget.style.background = "white";
                  }}
                >
                  <span style={{ fontSize: "20px", lineHeight: 1, flexShrink: 0 }}>{c.flag}</span>
                  <span>{c.label}</span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function LabInfoScreen() {
  const navigate = useNavigate();
  const { registerData, updateRegisterData } = useRegister();

  const [firstName, setFirstName] = useState(registerData.firstName || "");
  const [lastName, setLastName] = useState(registerData.lastName || "");
  const [labName, setLabName] = useState(registerData.labName || "");

  // Prefill country: context → browser locale → leeg
  const getBrowserCountry = () => {
    const lang = navigator.language || navigator.languages?.[0] || "";
    // navigator.language geeft bijv. "nl-NL" — check of dat in onze lijst staat
    const exact = COUNTRIES.find((c) => c.value === lang);
    if (exact) return exact.value;
    // Fallback: match alleen op landcode (laatste 2 letters)
    const countryCode = lang.split("-")[1];
    if (countryCode) {
      const partial = COUNTRIES.find((c) => c.value.endsWith(`-${countryCode}`));
      if (partial) return partial.value;
    }
    return "";
  };

  const [country, setCountry] = useState(registerData.country || getBrowserCountry());
  const [labType, setLabType] = useState(registerData.labType || "Dental");
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});

  const [loading, setLoading] = useState(false);

  const handleContinue = async (e) => {
    e.preventDefault();
    setError("");

    const newFieldErrors = {};
    if (!firstName.trim()) newFieldErrors.firstName = true;
    if (!lastName.trim()) newFieldErrors.lastName = true;
    if (!labName.trim()) newFieldErrors.labName = true;
    if (!country) newFieldErrors.country = true;

    if (Object.keys(newFieldErrors).length > 0) {
      setFieldErrors(newFieldErrors);
      setError("Please fill in all required fields");
      return;
    }

    setFieldErrors({});

    setLoading(true);

    try {
      const response = await apiClient.post("/organization", {
        labName: labName.trim(),
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        labType,
        country,
      });

      updateRegisterData({
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        labName: labName.trim(),
        country,
        labType,
        organization_id: response.data.organization_id,
      });

      navigate("/register/pricing");
    } catch (err) {
      console.error("CREATE_ORG error:", err);

      // 409 = user already has an org (browser back/forward scenario)
      // gewoon doorgaan naar pricing
      if (err.response?.status === 409) {
        updateRegisterData({
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          labName: labName.trim(),
          country,
          labType,
        });
        navigate("/register/pricing");
        return;
      }

      const message =
        err.response?.data?.message ||
        "Something went wrong. Please try again.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-container">
        <img
          src={logo}
          alt="Cadmus Logo"
          className="logo"
          draggable={false}
          onContextMenu={(e) => e.preventDefault()}
          onDragStart={(e) => e.preventDefault()}
        />

        <span className="login-header">Lab Information</span>
        <span className="login-sub-header">
          Who are you, and where do you work? We'll use this
          <br />
          information for your account setup and invoices.
        </span>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleContinue} style={{ width: "100%", textAlign: "left" }}>

          {/* Your name */}
          <span style={labelStyle}>Your name</span>
          <div style={{ display: "flex", gap: "8px" }}>
            <input
              type="text"
              value={firstName}
              onChange={(e) => { setFirstName(e.target.value); setFieldErrors((p) => ({ ...p, firstName: false })); }}
              placeholder="First name"
              autoComplete="off"
              style={{ ...inputStyle, opacity: firstName ? 1 : 0.5, borderColor: fieldErrors.firstName ? "#E91D51" : "#E0E0E0" }}
            />
            <input
              type="text"
              value={lastName}
              onChange={(e) => { setLastName(e.target.value); setFieldErrors((p) => ({ ...p, lastName: false })); }}
              placeholder="Last name"
              autoComplete="off"
              style={{ ...inputStyle, opacity: lastName ? 1 : 0.5, borderColor: fieldErrors.lastName ? "#E91D51" : "#E0E0E0" }}
            />
          </div>

          {/* Lab name */}
          <span style={labelStyle}>Lab name</span>
          <input
            type="text"
            value={labName}
            onChange={(e) => { setLabName(e.target.value); setFieldErrors((p) => ({ ...p, labName: false })); }}
            placeholder="Name of company, lab or organisation"
            autoComplete="off"
            style={{ ...inputStyle, opacity: labName ? 1 : 0.5, borderColor: fieldErrors.labName ? "#E91D51" : "#E0E0E0" }}
          />

          {/* Country */}
          <span style={labelStyle}>Country</span>
          <CountryDropdown
            value={country}
            onChange={(v) => { setCountry(v); setFieldErrors((p) => ({ ...p, country: false })); }}
            hasError={!!fieldErrors.country}
          />

          {/* Lab type */}
          <span style={labelStyle}>Lab type</span>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "24px" }}>
            {["Orthodontic", "Dental", "CAD"].map((type) => (
              <button
                key={type}
                type="button"
                onClick={() => setLabType(type)}
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px 16px",
                  border: labType === type ? "1.5px solid #6C44D4" : "1.5px solid #E0E0E0",
                  borderRadius: "8px",
                  background: "white",
                  cursor: "pointer",
                  fontFamily: "DM Sans",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#111",
                  textAlign: "left",
                  transition: "border-color 0.15s, background 0.15s",
                }}
              >
                <span
                  style={{
                    width: "18px",
                    height: "18px",
                    borderRadius: "50%",
                    boxSizing: "border-box",
                    flexShrink: 0,
                    border: labType === type ? "1.5px solid #6C44D4" : "1.5px solid #ccc",
                    // De dot is een radial-gradient: die centreert altijd exact
                    // in de padding-box, zonder los child-element.
                    background:
                      labType === type
                        ? "radial-gradient(circle at center, #6C44D4 0, #6C44D4 4.5px, white 5px)"
                        : "white",
                    transition: "border-color 0.15s",
                  }}
                />
                {type}
              </button>
            ))}
          </div>

          <ButtonPrimary type="submit" disabled={loading}>
            {loading ? "Saving..." : "Continue"}
          </ButtonPrimary>
        </form>
      </div>
    </div>
  );
}

export default LabInfoScreen;